(function () {
    'use strict';

    class CalendarPopoverPhoneItemComponent extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, AppStates) {
            super($scope, $injector);
            this.__objectType = 'CalendarPopoverPhoneItemComponent';
            this.AppStates = AppStates;
        }
    }

    Components.CalendarPopoverPhoneItem = {
        bindings: {
            icon: '@',
            phone: '<',
            label: '<'
        },
        controller: CalendarPopoverPhoneItemComponent,
        name : 'hbCalendarPopoverPhoneItem',
        templateUrl: 'angular/app/modules/core/features/calendar/calendar_popover/calendar_popover_phone_item.html',
    };

}());

